import { Button } from "design-system/atoms/Button"
import { Section } from "design-system/molecules/Section"
import { Plus } from "lucide-react"
import {
  KnowledgeBaseItems,
  KnowledgeBaseItemsRef,
} from "modules/knowledge/components/KnowledgeBaseItems"
import { useRef } from "react"
import { useTranslation } from "react-i18next"

type Props = {
  id: string
}

export function CampaignKnowledgeBase({ id }: Props) {
  const { t } = useTranslation()
  const knowledgeBaseItemsRef = useRef<KnowledgeBaseItemsRef>(null)

  const action = (
    <Button
      onClick={() => {
        knowledgeBaseItemsRef.current?.addItemToActiveTab()
      }}
    >
      <Plus className="h-4 w-4" />
      <span>{t("campaigns.detail.knowledgeBase.addButton")}</span>
    </Button>
  )

  return (
    <Section
      title={t("knowledge.knowledgeBase.title")}
      description={t("knowledge.knowledgeBase.description")}
      action={action}
    >
      <KnowledgeBaseItems ref={knowledgeBaseItemsRef} campaignId={id} />
    </Section>
  )
}
